// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__pP_Rv","search":"Settings_search__aLlbn","filter":"Settings_filter__EbDeO"};